import { institutionService } from '@/_services';
import { EventBus } from '@/event-bus';

const state = {
  currencyLocale: '',
  item: {},
  isLoading: false,
  salesOverview: {},
  isLoadingSalesOverview: false,
  deviceOpens: {},
  isLoadingDeviceOpens: false,
  logoURL: null,
};

const actions = {
  fetchStats({ commit }, { id, range }) {
    commit('setIsLoading', true);
    institutionService.getStats(id, range).then((response) => {
      commit('updateStats', response.data);
    }).catch((error) => {
      EventBus.$emit('toast-error', 'There has been an error fetching this data, please try again in a few seconds.');
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  fetchSalesOverview({ dispatch, commit }, { id, range }) {
    commit('setIsLoadingSalesOverview', true);
    return institutionService.getSalesOverview(id).then((response) => {
      if (response.data.url) {
        return response.data;
      }
      commit('updateSalesOverview', response.data);
      commit('updateCurrencyLocale', response.headers['x-currency-locale']);
      commit('setIsLoadingSalesOverview', false);
      return response;
    }).finally(() => {
    });
  },
  fetchDeviceOpens({ commit }, { id, range }) {
    commit('setIsFetchingDeviceOpens', true);
    institutionService.getDeviceOpens(id, range).then((response) => {
      commit('updateDeviceOpens', response.data);
    }).finally(() => {
      commit('setIsFetchingDeviceOpens', false);
    });
  },
  fetchCustomSalesOverview({ commit }, { url, range }) {
    commit('setIsLoadingSalesOverview', true);
    return institutionService.getCustomSalesOverview(url, range).then((response) => {
      commit('updateSalesOverview', response.data);
    }).finally(() => {
      commit('setIsLoadingSalesOverview', false);
    });
  },
};

const mutations = {
  setIsLoading(state, status) {
    state.isLoading = status;
  },
  updateCurrencyLocale(state, locale) {
    state.currencyLocale = locale; //  e.g. en-GB, en-US
  },
  updateLogoURL(state, logo) {
    state.logoURL = logo;
  },
  updateStats(state, item) {
    state.item = item;
  },
  updateSalesOverview(state, data) {
    state.salesOverview = data;
  },
  setIsLoadingSalesOverview(state, isLoading) {
    state.isLoadingSalesOverview = isLoading;
  },
  updateDeviceOpens(state, data) {
    state.deviceOpens = data;
  },
  setIsFetchingDeviceOpens(state, isLoading) {
    state.isLoadingDeviceOpens = isLoading;
  },
};

export const institutions = {
  namespaced: true,
  state,
  actions,
  mutations,
};
